import { ArrayChip, CurrencyDisplay, StatusChip } from "components";
import { formatDate, textCapitalization } from "utils";

export const columnTableSongResults = [
  {
    name: "song_title",
    title: "Songs",
  },
  {
    name: "traffic",
    title: "Traffic",
  },
  {
    name: "paid",
    title: "Paid",
    renderText: paid => (
      <CurrencyDisplay value={paid} decimalScale={2} suffix=",-" prefix="Rp" />
    ),
    headerAlign: "right",
  },
  {
    name: "unpaid",
    title: "Unpaid",
    renderText: unpaid => (
      <CurrencyDisplay
        value={unpaid}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
];
export const columnTable = () => [
  {
    name: "invoice_date",
    title: "Invoice Date",
    renderText: date => formatDate(date),
  },
  {
    name: "invoice_number",
    title: "Invoice Number",
  },

  {
    name: "client_name",
    title: "Client Name",
  },
  {
    name: "period",
    title: "Period",
  },
  {
    name: "invoice_type",
    title: "Type",
    renderText: item => (
      <StatusChip
        label={textCapitalization(item)}
        type={optionsType?.find(value => value?.value === item)?.color || ""}
      />
    ),
  },
  {
    name: "revenue",
    title: "Revenue",
    renderText: revenue => (
      <CurrencyDisplay
        value={revenue}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
  {
    name: "composer_revenue",
    title: "Composer/Author",
    renderText: revenue => (
      <CurrencyDisplay
        value={revenue}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
  {
    name: "paid_revenue",
    title: "Paid",
    renderText: revenue => (
      <CurrencyDisplay
        value={revenue}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
  {
    name: "unpaid_revenue",
    title: "Unpaid",
    renderText: revenue => (
      <CurrencyDisplay
        value={revenue}
        decimalScale={2}
        suffix=",-"
        prefix="Rp"
      />
    ),
    headerAlign: "right",
  },
];
export const columnTableSongDetail = (
  hideColumnRemainingRevenue,
  paymentComposer
) => [
  {
    name: "sales_invoice_number",
    title: "Sales Invoice No",
  },
  {
    name: "song_title",
    title: "Song",
  },
  ...(paymentComposer
    ? []
    : [
        {
          name: "composer",
          title: "Composer/Author",
          renderText: item => <ArrayChip list={item} />,
        },
        {
          name: "revenue",
          title: "Revenue",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
        {
          name: "publisher_percentage",
          title: "Publisher Percentage",
          renderText: percentage => `${percentage}%`,
        },
        {
          name: "publisher_revenue",
          title: "Publisher Revenue",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]),
  ...(hideColumnRemainingRevenue
    ? []
    : [
        {
          name: "composer_revenue",
          title: "Composer Revenue (Remaining)",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]),
  {
    name: "paid",
    title: "Paid",
    renderText: item => (
      <CurrencyDisplay value={item} decimalScale={2} suffix=",-" prefix="Rp" />
    ),
    headerAlign: "right",
  },
];

export const columnTableComposerInvoice = () => [
  {
    name: "invoice_date",
    title: "Invoice Date",
    renderText: date => formatDate(date),
  },
  {
    name: "invoice_number",
    title: "Invoice Number",
  },

  {
    name: "reference",
    title: "Reference",
    renderText: item => (item ? item : "-"),
  },

  {
    name: "payment_number",
    title: "Payment Number",
  },
  {
    name: "composer_name",
    title: "Composer",
  },
  {
    name: "invoice_value",
    title: "Invoice Value",
    headerAlign: "right",
    renderText: item => (
      <CurrencyDisplay value={item} decimalScale={2} prefix="Rp" />
    ),
  },
  {
    name: "generated_by",
    title: "Generated by",
  },

  {
    name: "status",
    title: "Status",
    renderText: status => (
      <StatusChip
        label={
          optionsInvoiceStatus?.find(value => value?.value === status)?.name ||
          "-"
        }
        type={
          optionsInvoiceStatus?.find(value => value?.value === status)?.color ||
          ""
        }
      />
    ),
  },
];

export const columnTableInvoice = ({ isStatus }) => [
  {
    name: "invoice_date",
    title: "Invoice Date",
    renderText: date => formatDate(date),
  },
  {
    name: "invoice_number",
    title: "Invoice Number",
  },

  {
    name: "client_name",
    title: "Client Name",
  },
  {
    name: "period",
    title: "Period",
  },
  {
    name: "invoice_type",
    title: "Type",
    renderText: item => (
      <StatusChip
        label={textCapitalization(item)}
        type={optionsType?.find(value => value?.value === item)?.color || ""}
      />
    ),
  },
  ...(isStatus === "revenue"
    ? [
        {
          name: "revenue",
          title: "Revenue",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]
    : isStatus === "composer_revenue"
    ? [
        {
          name: "composer_revenue",
          title: "Composer/Author",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]
    : isStatus === "paid"
    ? [
        {
          name: "paid_revenue",
          title: "Paid",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]
    : [
        {
          name: "unpaid_revenue",
          title: "Unpaid",
          renderText: revenue => (
            <CurrencyDisplay
              value={revenue}
              decimalScale={2}
              suffix=",-"
              prefix="Rp"
            />
          ),
          headerAlign: "right",
        },
      ]),
];
export const optionsType = [
  {
    name: "Claim",
    value: "claim",
    color: "success",
  },
  {
    name: "Usage",
    value: "usage",
    color: "active",
  },
];
export const optionsStatus = [
  {
    name: "Draft",
    value: "draft",
    color: "warning",
  },
  {
    name: "Waiting for Approval",
    value: "waiting_for_approval",
    color: "warning",
  },
  {
    name: "Waiting for Approval (Payment)",
    value: "waiting_for_approval_payment",
    color: "warning",
  },
  {
    name: "Approved",
    value: "approved",
    color: "success",
  },
  {
    name: "Paid Updating Dashboard",
    value: "paid_updating_dashboard",
    color: "warning",
  },
  {
    name: "Paid",
    value: "paid",
    color: "success",
  },
  {
    name: "Rejected",
    value: "rejected",
    color: "danger",
  },
];

export const optionsInvoiceStatus = [
  {
    name: "Draft",
    value: "draft",
    color: "warning",
  },
  {
    name: "Waiting for Approval",
    value: "waiting_for_approval",
    color: "warning",
  },
  {
    name: "Waiting for Approval (Payment)",
    value: "waiting_for_approval_payment",
    color: "warning",
  },
  {
    name: "Approved",
    value: "approved",
    color: "success",
  },
  {
    name: "Paid Updating Dashboard",
    value: "paid_updating_dashboard",
    color: "warning",
  },
  {
    name: "Paid",
    value: "paid",
    color: "success",
  },
  {
    name: "Rejected",
    value: "rejected",
    color: "danger",
  },
];
export const optionsStatusComposerPayment = [
  {
    name: "Requested",
    value: "requested",
    color: "warning",
  },
  {
    name: "Processed",
    value: "processed",
    color: "active",
  },
  {
    name: "Paid",
    value: "paid",
    color: "success",
  },
  {
    name: "Rejected",
    value: "rejected",
    color: "danger",
  },
];
export const chipStatus = [
  ...optionsStatus,
  { name: "Active", value: "active", color: "success" },
  { name: "Unpaid", value: "unpaid", color: "danger" },
];
